<template>
  <div class="navbar">
    <div class="naveLeft">
      <img src="../../assets/sites/logo.png" alt="" style="width: 40px">
      <span class="title">交通事故处理一体化平台</span>
    </div>
    <navMenu class="tab"/>
    <div class="loginOut" @click="logout">
      <span>退出</span>
      <img src="../../assets/images/list/loginOut.png" alt="">
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { api } from '@/plugins/api';
import { Mutations } from '@/store/mutations';
import videoCall from '@/phoneVideo/video-call';
import { getVideoTimeBy5G } from '@/api/accident/edit.js';
import navMenu from './navMenu'
export default {
  components: {
    navMenu
  },
    data() {
    return {
      saveLoading: false,
      personalInfo: {
        username: '',
        name: '',
        password: '',
        confirmPassword: '',
        remark: ''
      },
      personalInfoVisible: false,
      personalInfoSchema: {
        props: {
          labelWidth: '90px',
          size: 'default'
        },
        fields: {
          $grid: {
            type: 'grid',
            layout: [12, 12, 12, 12],
            props: {
              gutter: 10
            },
            fields: {
              username: {
                type: 'string',
                title: '用户账号',
                editable: false
              },
              name: {
                type: 'string',
                title: '用户姓名',
                placeholder: '请输入用户姓名'
              },
              password: {
                type: 'string',
                title: '密码',
                placeholder: '为空则不作修改',
                props: {
                  showPassword: true
                }
              },
              confirmPassword: {
                type: 'string',
                title: '确认密码',
                placeholder: '请重复输入密码',
                props: {
                  showPassword: true
                }
              }
            }
          },
          remark: {
            type: 'text',
            title: '备注',
            props: {
              rows: 5
            }
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device', 'name', 'visitedViews']),
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    isInRoom() {
      return !!~this.visitedViews.findIndex(
        ({ name }) => name === 'AccidentAdd'
      );
    },
    setting: {
      get() {
        return this.$store.state.settings.showSettings;
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        });
      }
    },
    sysUser() {
      return this.$store.state.user.sysUser;
    },
    accidentId() {
      return this.$route.params.id;
    }
  },
  methods: {
    changeReadyState() {
      console.log('enter changeReadyState',api.video.trtc.ready)
      api.video.trtc.ready.r().then(res => {
        console.log('enter changeReadyState. res:',res)
        if (res && res.code === '200') {
          this.$store.commit(Mutations.CHANGE_READY_STATE); // 修改就绪样式
        }
      });
      localStorage.setItem('isReady','1');
    },
    changeLeaveState() {
      api.video.trtc.leave.r().then(res => {
        if (res && res.code === '200') {
          this.$store.commit(Mutations.CHANGE_LEAVE_STATE); // 修改离岗样式
        }
      });
      localStorage.setItem('isReady','0');
    },
    async savePersonalInfo() {
      if (this.personalInfo.password) {
        if (!this.personalInfo.confirmPassword) {
          this.$message.error('请填写确认密码');
          return;
        }
        if (this.personalInfo.password !== this.personalInfo.confirmPassword) {
          this.$message.error('两次密码输入不一致');
          return;
        }
      }

      try {
        this.saveLoading = true;
        await this.$api.system.user.modifyPersonalInfo.r(this.personalInfo);
        this.personalInfoVisible = false;
        this.logout();
      } catch (e) {
      } finally {
        this.saveLoading = false;
      }
    },
    showPersonalInfoDialog() {
      this.personalInfo.name = this.$store.state.user.name;
      this.personalInfo.username = this.$store.state.user.username;
      this.personalInfo.remark = this.$store.state.user.sysUser.remark;
      this.personalInfoVisible = true;
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    async logout() {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          location.href = '/';
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.navbar {
  position: relative;
  width: 100%;
  height: 90px;
  //background: url("../../assets/images/list/header.png") no-repeat;
  //background-size: 100% 100%;
  background-color: rgba(0,0,0,0.5);
  line-height: 90px;
  .naveLeft {
    position: absolute;
    left: 40px;
    line-height: 90px;
    img {
      margin-top: 20px;
    }
    .title {
      vertical-align: top;
      color: #D5F0FF;
      margin-left: 20px;
      letter-spacing: 1px;
      font-size: 20px;
    }
  }
  .tab {
      position: absolute;
      left: 540px;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  .loginOut {
    position: absolute;
    right: 40px;
    span {
      color: #B1E3FF;
      font-size: 18px;
      margin-right: 10px;
      cursor: pointer;
    }
    img {
      vertical-align: text-bottom;
      cursor: pointer;
    }
  }
}
</style>
